import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { useSelector } from "react-redux";
import { TextArea } from "semantic-ui-react";
import {
  getVehicleAllocations,
  vehicleAssignmentSearch,
} from "../../../../api/jobApi";
import { getOtherRefSearchDropdown } from "../../../../api/keyvalue";
import SearchDropdown from "../../../input/SearchDropdown";
import LoadingSpinner from "../../../LoadingSpinner";

import Button from "../../../input/Button";
import Dropdown from "../../../input/Dropdown";
import Input from "../../../input/Input";
import UIMessage from "../../../UIMessage";
import { toast } from "react-toastify";
import {
  AUTHORITY_TYPE,
  FORMS,
  gridHeaders,
  locationSocketUrl,
  MODULES,
} from "../../../../const";
import useAuthority from "../../../../hooks/useAuthority";
import { Info, Settings, Truck } from "react-feather";
import Modal from "../../../Modal";
import JobVehicleStatus from "../VehicleStatus/JobVehicleStatus";
import WebSocketConnection from "../../../../service/WebSocketConnection";

const VehicleAssignmentForm = forwardRef(
  (
    {
      jobId,
      jobCode,
      requestId,
      requestCode,
      type,
      dropdown,
      isLoading,
      currentValue,
      editMode,
      errors,
      handleRemove,
      staId,
      vehicleTypeId,
      setIsAssignButtonEnabled,
      vaeList,
      vreList,
      isBackhaul,
      onRejectBackhaul,
    },
    ref,
  ) => {
    const [searchFieldReset, setSearchFieldReset] = useState(false);
    const user = useSelector((state) => state.user);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
    const [currentErrors, setCurrentErrors] = useState(errors);
    const [vehicleAllocations, setVehicleAllocations] = useState([]);
    const driverRef = useRef();
    const helperRef = useRef();
    const modalRef = useRef();
    const wsConnection = useMemo(
      () => new WebSocketConnection(locationSocketUrl, {}),
      [],
    );

    useEffect(() => {
      setCurrentErrors(errors);
    }, [errors]);

    const { deletePermission } = useAuthority({
      type: AUTHORITY_TYPE.FORM,
      module: MODULES.Transaction,
      form: FORMS.VEHICLE_ASSIGNMENT.VEHICLE.form,
      editMode: editMode,
      authenticated: true,
      needDeletePermission: true,
    });

    const vehicleRef = useRef();

    const [vehicleAssignmentState, setVehicleAssignmentState] = useState({
      jobRequest: requestId,
      jobId: jobId,
      staId: staId,
      requestVehicleType: "",
      jobTransporter: "",
      transporterValue: "",
      jobVehicle: "",
      vehicleValue: "",
      jobDriver: "",
      jobAdditionalDriverMobile: "", //*
      driverValue: "",
      jobHelper: "",
      helperValue: "",
      jobSecondaryDriver: "",
      secDriverValue: "",
      jobSecondaryHelper: "",
      secHelperValue: "",
      reasonToChange: "",
      remark: "",
      block: 2,
      vacFromDate: null,
      vacToDate: null,
    });

    const [commitment, setCommitment] = useState(2);
    const [exactCbm, setExactCbm] = useState(2);

    // useEffect(() => {
    //   if (editMode) {
    //     setVehicleAssignmentState(currentValue);
    //   }
    // }, [editMode, currentValue]);

    useEffect(() => {
      if (editMode && currentValue) {
        setVehicleAssignmentState((prevState) => ({
          ...prevState,
          ...currentValue,
        }));

        if (currentValue.jobVehicle && currentValue.jobDriver) {
          setIsAssignButtonEnabled(true);
        } else {
          setIsAssignButtonEnabled(false);
        }
      }
    }, [editMode, currentValue, setIsAssignButtonEnabled]);

    useImperativeHandle(ref, () => ({
      getData: () => ({
        jobVehicleAssignment: vehicleAssignmentState,
        jobVehicleHistoryRequest: {
          jvhJob: jobId,
          jvhVehicle: vehicleAssignmentState.jobVehicle,
          jvhTransporter: vehicleAssignmentState.jobTransporter,
          jvhDriver: vehicleAssignmentState.jobDriver,
          jvhHelper: vehicleAssignmentState.jobHelper,
          jvhSecondaryDriver: vehicleAssignmentState.jobSecondaryDriver,
          jvhSecondaryHelper: vehicleAssignmentState.jobSecondaryHelper,
          jvhVehicleChange: vehicleAssignmentState.reasonToChange,
          jvhVehicleChangeComment: vehicleAssignmentState.remark,
        },
        author: user.username,
      }),

      resetBackhaulFields: () => {
        setVehicleAssignmentState((prevState) => ({
          ...prevState,
          jobTransporter: "",
          transporterValue: "",
          jobVehicle: "",
          vehicleValue: "",
          jobDriver: "",
          driverValue: "",
          jobAdditionalDriverMobile: "",
          jobHelper: "",
          helperValue: "",
          jobSecondaryDriver: "",
          secDriverValue: "",
          jobSecondaryHelper: "",
          secHelperValue: "",
          reasonToChange: "",
          remark: "",
          jobIsBackhaul: false,
        }));

        setSearchFieldReset(true);
        setIsAssignButtonEnabled(false);

        vehicleRef.current?.reset?.();
        driverRef.current?.reset?.();
        helperRef.current?.reset?.();
      },
    }));

    const onVehicleSelect = (data) => {
      setVehicleAssignmentState((prevState) => ({
        ...prevState,
        jobVehicle: data.value,
        vehicleValue: data.text,
      }));
      handleFieldChange();
      if (
        vehicleAssignmentState.jobDriver === "" ||
        vehicleAssignmentState.jobDriver === null
      ) {
        setVehicleAssignmentState((prevState) => ({
          ...prevState,
          jobDriver: data.drvId,
          driverValue: data.driverName,
        }));
      }
      if (
        vehicleAssignmentState.jobTransporter === "" ||
        vehicleAssignmentState.jobTransporter === null
      ) {
        setVehicleAssignmentState((prevState) => ({
          ...prevState,
          jobTransporter: data.transId ? data.transId : "",
          transporterValue: data.transporterName ? data.transporterName : "",
        }));
      }
      if (
        vehicleAssignmentState.jobHelper === "" ||
        vehicleAssignmentState.jobHelper === null
      ) {
        setVehicleAssignmentState((prevState) => ({
          ...prevState,
          jobHelper: data.helId ? data.helId : "",
          helperValue: data.helperName ? data.helperName : "",
        }));
      }
      if (
        vehicleAssignmentState.jobSecondaryDriver === "" ||
        vehicleAssignmentState.jobSecondaryDriver === null
      ) {
        setVehicleAssignmentState((prevState) => ({
          ...prevState,
          jobSecondaryDriver: data.secdrvId !== 0 ? data.secdrvId : "",
          secDriverValue: data.secdrvName ? data.secdrvName : "",
        }));
      }
      if (
        vehicleAssignmentState.jobSecondaryHelper === "" ||
        vehicleAssignmentState.jobSecondaryHelper === null
      ) {
        setVehicleAssignmentState((prevState) => ({
          ...prevState,
          jobSecondaryHelper: data.sechelId !== 0 ? data.sechelId : "",
          secHelperValue: data.sechelName ? data.sechelName : "",
        }));
      }
    };

    const onVehicleSelectInfo = (e) => {
      e.preventDefault();
      modalRef.current?.showModal();
    };

    const handleFieldChange = () => {
      setIsAssignButtonEnabled(true);
    };

    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <form
            className="ui form"
            style={{ overflowY: "auto", height: "70vh" }}
          >
            <div className="ui segment">
              <h4 className="ui dividing header">Vehicle Assignment Details</h4>
              <div className="ui segment">
                <div className="three fields">
                  <div className={`field`}>
                    <label>Request</label>
                    <input
                      type="text"
                      name="jobRequest"
                      placeholder="Request"
                      value={requestCode}
                      disabled={true}
                    />
                  </div>
                  <div className={`field`}>
                    <label>Job</label>
                    <input
                      type="text"
                      name="job"
                      placeholder="Job"
                      value={jobCode}
                      disabled={true}
                    />
                  </div>
                  <div className={`field`}>
                    <label>Request Vehicle Type</label>
                    <input
                      type="text"
                      name="requestVehicleType"
                      placeholder="Request Vehicle Type"
                      value={type}
                      disabled={true}
                    />
                  </div>
                </div>
              </div>

              {isBackhaul && (
                  <div
                      className="ui warning message"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "16px",
                      }}
                  >
                    <div>
                      This job has a backhaul vehicle. Its details are shown below.
                    </div>

                    <Button
                        className="ui red button"
                        type="button"
                        label="Reject"
                        onClick={onRejectBackhaul}
                    />
                  </div>
              )}

              <div className="two fields">
                <SearchDropdown
                    key={2}
                    readOnly={editMode}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    returnFullObject={true}
                    onResultSelect={onVehicleSelect}
                    api={vehicleAssignmentSearch}
                    ref={vehicleRef}
                    clearable={true}
                    multiGrid={true}
                    module={MODULES.Transaction}
                    form={FORMS.VEHICLE_ASSIGNMENT.VEHICLE.form}
                    field="jobVehicle"
                    editMode={editMode}
                    multiGridCurrentValue={
                      vehicleAssignmentState.vehicleValue
                          ? vehicleAssignmentState.vehicleValue
                          : ""
                    }
                    onClear={() => {
                      setVehicleAssignmentState((prevState) => ({
                        ...prevState,
                        jobVehicle: "",
                        vehicleValue: "",
                      }));
                      handleFieldChange();
                    }}
                    fieldInfo={{
                      tableName: "masterdata.tms_m_vehicle_details",
                      primaryKey: "veh_id",
                      fieldName: "veh_vehicleno",
                      ids: vehicleAssignmentState.jobVehicle,
                    }}
                    apiDependency={{
                      lTransporter:
                          vehicleAssignmentState.jobTransporter !== ""
                              ? vehicleAssignmentState.jobTransporter
                              : null,
                      lDriver:
                          vehicleAssignmentSearch.jobDriver !== ""
                              ? vehicleAssignmentSearch.jobDriver
                              : null,
                      lVehicleType: vehicleTypeId,
                      cbm: exactCbm === 1 ? -1 : -2,
                      lCommit: commitment,
                      fullObject: true,
                      status: 2,
                    }}
                    required={true}
                    label="Vehicle"
                    error={currentErrors.jobVehicle}
                    resetError={() => {
                      setCurrentErrors((prevState) => {
                        const {jobVehicle: _, ...rest} = prevState;
                        return rest;
                      });
                    }}
                />

                <Button
                  className="bg-transparent ui button"
                  style={{
                    height: "37px",
                    marginTop: "28px",
                    padding: "5px 0px 5px 5px",
                  }}
                  onClick={onVehicleSelectInfo}
                  disabled={vehicleAssignmentState?.jobVehicle === ""}
                  Icon={Info}
                ></Button>

                <SearchDropdown
                  key={1}
                  editMode={editMode}
                  readOnly={editMode}
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  multiGrid={true}
                  multiGridCurrentValue={
                    vehicleAssignmentState.transporterValue
                      ? vehicleAssignmentState.transporterValue
                      : ""
                  }
                  onResultSelect={(data) => {
                    setVehicleAssignmentState((prevState) => ({
                      ...prevState,
                      jobTransporter: data,
                      jobVehicle: "",
                      vehicleValue: "",
                      jobDriver: "",
                      driverValue: "",
                    }));
                    vehicleRef.current.reset();
                    handleFieldChange();
                  }}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "Transporter",
                  }}
                  clearable={true}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_statkeholder",
                    primaryKey: "stk_id",
                    fieldName: "stk_name",
                    ids: vehicleAssignmentState.jobTransporter,
                  }}
                  onClear={() => {
                    setVehicleAssignmentState((prevState) => ({
                      ...prevState,
                      jobTransporter: "",
                      transporterValue: "",
                      jobVehicle: "",
                      vehicleValue: "",
                      jobDriver: "",
                      driverValue: "",
                    }));
                    handleFieldChange();
                  }}
                  label="Transporter"
                  module={MODULES.Transaction}
                  form={FORMS.VEHICLE_ASSIGNMENT.VEHICLE.form}
                  field="jobTransporter"
                />
              </div>
              <div className="two fields">
                <Dropdown
                  readOnly={editMode}
                  options={dropdown.yesNo}
                  style={{ height: "20px" }}
                  placeholder="Commitment Vehicles"
                  value={commitment}
                  onChange={(e, data) => setCommitment(data.value)}
                  label="Commitment Vehicles"
                  clearable={false}
                />
                <Dropdown
                  readOnly={editMode}
                  options={dropdown.yesNo}
                  style={{ height: "20px" }}
                  placeholder="Exact CBM"
                  value={exactCbm}
                  onChange={(e, data) => setExactCbm(data.value)}
                  label="Exact CBM"
                  clearable={false}
                />
              </div>
              <div className="two fields">
                <SearchDropdown
                  threshold={1}
                  ref={driverRef}
                  disabled={!vehicleAssignmentState.jobTransporter}
                  key={3}
                  editMode={editMode}
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  module={MODULES.Transaction}
                  form={FORMS.VEHICLE_ASSIGNMENT.VEHICLE.form}
                  field="jobDriver"
                  multiGrid={true}
                  multiGridCurrentValue={
                    vehicleAssignmentState.driverValue
                      ? vehicleAssignmentState.driverValue
                      : ""
                  }
                  onResultSelect={(data) => {
                    if (data === vehicleAssignmentState.jobSecondaryDriver) {
                      toast.error(
                        "The same driver cannot be assigned as both primary and secondary driver",
                        { autoClose: 5000, containerId: "Modal" },
                      );
                      driverRef.current.reset();
                      return;
                    } else {
                      setVehicleAssignmentState((prevState) => ({
                        ...prevState,
                        jobDriver: data,
                      }));
                      handleFieldChange();
                    }
                  }}
                  clearable={true}
                  onClear={() => {
                    setVehicleAssignmentState((prevState) => ({
                      ...prevState,
                      jobDriver: "",
                      driverValue: "",
                    }));
                    handleFieldChange();
                  }}
                  api={getOtherRefSearchDropdown}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_employee",
                    primaryKey: "emp_id",
                    fieldName: "emp_fullname",
                    ids: vehicleAssignmentState.jobDriver,
                  }}
                  apiDependency={{
                    type: "active_approved_employee",
                    value: "Driver",
                    param1: vehicleAssignmentState.jobTransporter?.toString(),
                  }}
                  required={true}
                  label="Driver"
                  error={currentErrors.jobDriver}
                  resetError={() => {
                    setCurrentErrors((prevState) => {
                      const { jobDriver: _, ...rest } = prevState;
                      return rest;
                    });
                  }}
                />

                <Input
                  label="Additional Mobile Number"
                  error={currentErrors.jobAdditionalDriverMobile}
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { jobAdditionalDriverMobile: _, ...rest } =
                        prevState;
                      return rest;
                    })
                  }
                  placeholder="07XXXXXXXX"
                  value={vehicleAssignmentState.jobAdditionalDriverMobile}
                  onChange={(e) => {
                    setVehicleAssignmentState((prevState) => ({
                      ...prevState,
                      jobAdditionalDriverMobile: e.target.value,
                    }));
                    handleFieldChange();
                  }}
                />
              </div>

              <div className="two fields">
                <SearchDropdown
                  threshold={1}
                  ref={helperRef}
                  disabled={!vehicleAssignmentState.jobTransporter}
                  key={4}
                  editMode={editMode}
                  module={MODULES.Transaction}
                  form={FORMS.VEHICLE_ASSIGNMENT.VEHICLE.form}
                  field="jobHelper"
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  multiGrid={true}
                  multiGridCurrentValue={
                    vehicleAssignmentState.helperValue
                      ? vehicleAssignmentState.helperValue
                      : ""
                  }
                  onResultSelect={(data) => {
                    if (data === vehicleAssignmentState.jobSecondaryHelper) {
                      toast.error(
                        "The same helper cannot be assigned as both primary and secondary helper",
                        { autoClose: 5000, containerId: "Modal" },
                      );
                      helperRef.current.reset();
                      return;
                    } else {
                      setVehicleAssignmentState((prevState) => ({
                        ...prevState,
                        jobHelper: data,
                      }));
                      handleFieldChange();
                    }
                  }}
                  clearable={true}
                  onClear={() => {
                    setVehicleAssignmentState((prevState) => ({
                      ...prevState,
                      jobHelper: "",
                      helperValue: "",
                    }));
                    handleFieldChange();
                  }}
                  api={getOtherRefSearchDropdown}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_employee",
                    primaryKey: "emp_id",
                    fieldName: "emp_fullname",
                    ids: vehicleAssignmentState.jobHelper,
                  }}
                  apiDependency={{
                    type: "active_approved_employee",
                    value: "Helper",
                    param1: vehicleAssignmentState.jobTransporter?.toString(),
                  }}
                  label="Helper"
                />
                <SearchDropdown
                  threshold={1}
                  ref={driverRef}
                  disabled={!vehicleAssignmentState.jobTransporter}
                  key={5}
                  editMode={editMode}
                  module={MODULES.Transaction}
                  form={FORMS.VEHICLE_ASSIGNMENT.VEHICLE.form}
                  field="jobSecDriver"
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  multiGrid={true}
                  multiGridCurrentValue={
                    vehicleAssignmentState.secDriverValue
                      ? vehicleAssignmentState.secDriverValue
                      : ""
                  }
                  onResultSelect={(data) => {
                    if (data === vehicleAssignmentState.jobDriver) {
                      toast.error(
                        "The same driver cannot be assigned as both primary and secondary driver",
                        { autoClose: 5000, containerId: "Modal" },
                      );
                      driverRef.current.reset();
                      return;
                    } else {
                      setVehicleAssignmentState((prevState) => ({
                        ...prevState,
                        jobSecondaryDriver: data,
                      }));
                      handleFieldChange();
                    }
                  }}
                  clearable={true}
                  onClear={() => {
                    setVehicleAssignmentState((prevState) => ({
                      ...prevState,
                      jobSecondaryDriver: "",
                      secDriverValue: "",
                    }));
                    handleFieldChange();
                  }}
                  api={getOtherRefSearchDropdown}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_employee",
                    primaryKey: "emp_id",
                    fieldName: "emp_fullname",
                    ids: vehicleAssignmentState.jobSecondaryDriver,
                  }}
                  apiDependency={{
                    type: "active_approved_employee",
                    value: "Driver",
                    param1: vehicleAssignmentState.jobTransporter?.toString(),
                  }}
                  label="Sec Driver"
                />
              </div>

              <div className="two fields">
                <SearchDropdown
                  threshold={1}
                  ref={helperRef}
                  disabled={!vehicleAssignmentState.jobTransporter}
                  key={6}
                  editMode={editMode}
                  reset={searchFieldReset}
                  module={MODULES.Transaction}
                  form={FORMS.VEHICLE_ASSIGNMENT.VEHICLE.form}
                  field="jobSecHelper"
                  setReset={setSearchFieldReset}
                  multiGrid={true}
                  multiGridCurrentValue={
                    vehicleAssignmentState.secHelperValue
                      ? vehicleAssignmentState.secHelperValue
                      : ""
                  }
                  onResultSelect={(data) => {
                    if (data === vehicleAssignmentState.jobHelper) {
                      toast.error(
                        "The same helper cannot be assigned as both primary and secondary helper",
                        { autoClose: 5000, containerId: "Modal" },
                      );
                      helperRef.current.reset();
                      return;
                    } else {
                      setVehicleAssignmentState((prevState) => ({
                        ...prevState,
                        jobSecondaryHelper: data,
                      }));
                      handleFieldChange();
                    }
                  }}
                  clearable={true}
                  onClear={() => {
                    setVehicleAssignmentState((prevState) => ({
                      ...prevState,
                      jobSecondaryHelper: "",
                      secHelperValue: "",
                    }));
                    handleFieldChange();
                  }}
                  api={getOtherRefSearchDropdown}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_employee",
                    primaryKey: "emp_id",
                    fieldName: "emp_fullname",
                    ids: vehicleAssignmentState.jobSecondaryHelper,
                  }}
                  apiDependency={{
                    type: "active_approved_employee",
                    value: "Helper",
                    param1: vehicleAssignmentState.jobTransporter?.toString(),
                  }}
                  label="Sec Helper"
                />
              </div>
            </div>

            {deletePermission && editMode && vreList.includes(staId) && (
              <div className="ui segment">
                <h4 className="ui dividing header">Remove Vehicle</h4>
                <Dropdown
                  options={dropdown.reasonToChangeOpt}
                  style={{ height: "20px" }}
                  placeholder="Reason to Change"
                  value={vehicleAssignmentState.reasonToChange}
                  onChange={(e, data) =>
                    setVehicleAssignmentState((prevState) => ({
                      ...prevState,
                      reasonToChange: data.value,
                    }))
                  }
                  error={currentErrors.vehicleChange}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { vehicleChange: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  label="Reason to Remove"
                  required
                />

                <div className={`field`}>
                  <label>
                    <label
                      style={{
                        color: "#9f3a38",
                        fontSize: "20px",
                        marginRight: "2px",
                      }}
                    >
                      *
                    </label>
                    Remark
                  </label>
                  <TextArea
                    rows={2}
                    placeholder="Type here..."
                    onChange={(e) =>
                      setVehicleAssignmentState((prevState) => ({
                        ...prevState,
                        remark: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="three fields">
                  <Dropdown
                    options={dropdown.yesNo}
                    style={{ height: "20px" }}
                    placeholder="Block"
                    value={vehicleAssignmentState.block}
                    onChange={(e, data) =>
                      setVehicleAssignmentState((prevState) => ({
                        ...prevState,
                        block: data.value,
                      }))
                    }
                    error={currentErrors.block}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { block: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    label="Block"
                    required
                  />

                  <Input
                    required={vehicleAssignmentState.block === 1}
                    label="From Date"
                    error={currentErrors.vacFromDate}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { vacFromDate: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    type="date"
                    name="fromdate"
                    min={new Date().toISOString().split("T")[0]}
                    placeholder="From Date"
                    value={vehicleAssignmentState.vacFromDate}
                    onChange={(e) =>
                      setVehicleAssignmentState((prev) => ({
                        ...prev,
                        vacFromDate: e.target.value,
                      }))
                    }
                  />
                  <Input
                    required={vehicleAssignmentState.block === 1}
                    label="To Date"
                    error={currentErrors.vacToDate}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { vacToDate: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    type="date"
                    name="todate"
                    min={new Date().toISOString().split("T")[0]}
                    placeholder="To Date"
                    value={vehicleAssignmentState.vacToDate}
                    disabled={
                      vehicleAssignmentState.vacFromDate === "" ||
                      vehicleAssignmentState.vacFromDate === null
                    }
                    onChange={(e) => {
                      if (e.target.value < vehicleAssignmentState.vacFromDate) {
                        setCurrentErrors((prev) => ({
                          ...prev,
                          vacToDate: "To date should be greater than from date",
                        }));
                        setVehicleAssignmentState((prev) => ({
                          ...prev,
                          vacToDate: null,
                        }));
                      } else {
                        setCurrentErrors((prev) => ({
                          ...prev,
                          vacToDate: "",
                        }));
                        setVehicleAssignmentState((prev) => ({
                          ...prev,
                          vacToDate: e.target.value,
                        }));
                      }
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    className="ui primary right floated button"
                    disabled={
                      !vaeList.includes(staId) ||
                      !deletePermission ||
                      !vehicleAssignmentState.reasonToChange ||
                      !vehicleAssignmentState.remark ||
                      (vehicleAssignmentState.block === 1 &&
                        (!vehicleAssignmentState.vacFromDate ||
                          !vehicleAssignmentState.vacToDate))
                    }
                    onClick={async () => {
                      setIsDeleteLoading(true);
                      if (vehicleAssignmentState.block === 1) {
                        const response = await getVehicleAllocations(
                          vehicleAssignmentState.jobVehicle,
                        );
                        if (response && response.length > 1) {
                          setVehicleAllocations(
                            response
                              .filter((veh) => veh.jobId !== jobId)
                              .map((veh) => veh.jobCode),
                          );
                          toast.error(
                            "Cannot block a vehicle that is already assigned to other jobs",
                            { containerId: "Modal", autoClose: 3000 },
                          );
                          setIsDeleteLoading(false);
                          return;
                        }
                      }
                      await handleRemove();
                      setIsDeleteLoading(false);
                    }}
                    label="Remove Vehicle"
                    isLoading={isDeleteLoading}
                  />
                </div>
              </div>
            )}
            {vehicleAllocations.length > 0 && (
              <UIMessage type="negative" width="100%" centered={false}>
                <div className="content">
                  <div className="header">
                    Cannot block this vehicle since it is already assigned to
                    below jobs
                  </div>

                  <p>
                    <div className="content">
                      <ul>
                        {vehicleAllocations.map((job) => (
                          <div>{job}</div>
                        ))}
                      </ul>
                    </div>
                  </p>
                </div>
              </UIMessage>
            )}
            <Modal
              ref={modalRef}
              closeButton={true}
              minWidth={"1000px"}
              onCloseCleanUp={() => {
                wsConnection.disconnect();
              }}
              clickOutSide={true}
            >
              <JobVehicleStatus
                vehicleId={vehicleAssignmentState.jobVehicle}
                driverId={vehicleAssignmentState.jobDriver}
                vehicleInfoOnly={true}
                // isHideTabs={true}
              />
            </Modal>
          </form>
        )}
      </>
    );
  },
);

export default VehicleAssignmentForm;
